// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cb5119ff","455":"8ef73f8d","977":"38d071f0"}[chunkId] + ".chunk.js";
};